function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 3.495
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.207 57.728c.723 0 1.308-.585 1.308-1.309v-3.075c0-.723-.585-1.308-1.308-1.308H10.819c-.723 0-1.308.585-1.308 1.308v3.075c0 .724.585 1.309 1.308 1.309z",
  strokeWidth: 0.9247071
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.626 47.19H49.4v4.847H11.626z",
  strokeWidth: 0.9247071
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "bevel",
  d: "M49.4 47.19l-3.884-4.354H15.51l-3.884 4.354z",
  strokeWidth: 0.9247071
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M50.584 12.336l-5.068 4.848H15.51l-5.084-4.848z",
  strokeWidth: 0.9247071
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.51 17.184h29.966V42.84H15.511z",
  strokeWidth: 0.9247071
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.35 2.774h-6.99v4.494l-3.922 1.3-3.617-1.3V2.774h-8.615v4.494l-3.617 1.3-3.922-1.3V2.774h-6.99c-.69 0-1.25.585-1.25 1.307v8.27h40.175V4.08c0-.722-.561-1.308-1.252-1.308z",
  strokeLinecap: "square",
  strokeWidth: 0.9247071
}));

function SvgWhiteRook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _ref);
}

export default SvgWhiteRook;